<!--
 * @Deprecated: 使用组件来实现
 * @FileDescription: 模仿 input[readonly]
 * @Author: 刘凯
 * @Date: 2021-03-08 17:37:32
 * @LastEditors: “周晓清“ “zhouxq@yxt.com”
 * @LastEditTime: 2022-11-25 15:30:16
-->
<template>
  <article
    :class="['biz-plan-input-readonly color-gray-9 yxtbizf-br-4 pt8 pl12', $slots.suffix ? 'pr36' : 'pr12', isTag ? 'pb4' : 'pb8',disabled?'biz-plan-input-readonly__color':'']"
    @mouseenter="$slots.default && (hovering = true)"
    @mouseleave="$slots.default && (hovering = false)"
    @click="$emit('click')">
    <div v-if="placeholder && !$slots.default" class="biz-plan-input-readonly__placholder">{{ placeholder }}</div>
    <div v-if="$slots.default" class="biz-plan-input-readonly__content" :class="isSupportWarp ? 'text-nowrap' : ''">
      <slot />
    </div>
    <div v-if="!clearable || ($slots.suffix && !hovering)" class="biz-plan-input-readonly__suffix">
      <slot name="suffix" />
    </div>
    <div v-else class="biz-plan-input-readonly__suffix">
      <i v-if='clearable'
         class="yxt-input__icon yxt-icon-error yxt-input__clear cursor-p"
         @click.stop="(hovering = false,$emit('clear'))"></i>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    placeholder: String,
    contentType: String, // 内容呈现形式：文本（默认）、tag标签
    isSupportWarp: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hovering: false
    };
  },
  computed: {
    isTag() {
      return this.contentType === 'tag';
    }
  }
};
</script>
